module.exports = __webpack_public_path__ + "media/educators/listbuilder@2x-71479dba.png";